<template>
  <b-card
    v-if="accessEndDate"
    class="text-center"
  >
    <b-card-title>{{ title }}</b-card-title>
    <b-card-text>
      {{ message }}
    </b-card-text>
  </b-card>
  <b-alert
    v-else
    variant="danger"
    show
    class="p-2"
  >
    {{ unavailableMessage }}
  </b-alert>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BAlert,
} from 'bootstrap-vue'

export default {
  name: 'CancellationResultCard',
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BAlert,
  },
  props: {
    accessEndDate: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    unavailableMessage: {
      type: String,
      required: true,
    },
  },
}
</script>
